(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('ls-cart-drawer')) {
    customElements.define(
      'ls-cart-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.lastTrigger = null;

          this.onClick = (event) => {
            const opener = event.target.closest('[data-cart-open]');
            if (opener) {
              event.preventDefault();
              this.open(opener);
              return;
            }
            if (!this.contains(event.target)) return;
            if (event.target.closest('[data-cart-close]')) {
              this.dialog.close();
              return;
            }
            const remove = event.target.closest('[data-cart-remove]');
            if (remove) {
              event.preventDefault();
              this.changeLine(Number(remove.dataset.cartRemove), 0);
            }
          };

          this.onSubmit = (event) => {
            const form = event.target.closest('[data-ls-product-form]');
            if (!form || event.submitter?.closest('.shopify-payment-button')) return;
            event.preventDefault();
            this.add(form, event.submitter);
          };

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', () => {
            if (this.lastTrigger && document.contains(this.lastTrigger)) this.lastTrigger.focus();
          });

          document.addEventListener('click', this.onClick);
          document.addEventListener('submit', this.onSubmit);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onClick);
          document.removeEventListener('submit', this.onSubmit);
        }

        open(trigger) {
          this.lastTrigger = trigger || document.activeElement;
          if (!this.dialog.open) this.dialog.showModal();
        }

        sectionsUrl() {
          return window.location.pathname;
        }

        render(sections) {
          const html = sections && sections['cart-drawer'];
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-inner]');
          const current = this.querySelector('[data-cart-inner]');
          if (fresh && current) {
            current.replaceWith(fresh);
            document.dispatchEvent(
              new CustomEvent('ls:cart-updated', { detail: { count: Number(fresh.dataset.count) || 0 } })
            );
          }
        }

        add(form, submitter) {
          const button = submitter || form.querySelector('[data-add-button]');
          const errorBox = form.querySelector('[data-form-error]');
          if (button) {
            button.setAttribute('aria-busy', 'true');
            button.disabled = true;
          }
          if (errorBox) errorBox.hidden = true;

          const body = new FormData(form);
          body.append('sections', 'cart-drawer');
          body.append('sections_url', this.sectionsUrl());

          window.LaunchStudio.fetchSections(window.LaunchStudio.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body
          })
            .then((data) => {
              this.render(data.sections);
              this.open(button);
              const close = this.querySelector('[data-cart-close]');
              if (close) close.focus();
            })
            .catch((error) => {
              if (errorBox) {
                errorBox.textContent = error.message || this.dataset.errorGeneric;
                errorBox.hidden = false;
              } else {
                form.submit();
              }
            })
            .finally(() => {
              if (button) {
                button.removeAttribute('aria-busy');
                button.disabled = false;
              }
            });
        }

        changeLine(line, quantity) {
          this.setAttribute('aria-busy', 'true');
          window.LaunchStudio.fetchSections(window.LaunchStudio.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: this.sectionsUrl() })
          })
            .then((data) => {
              this.render(data.sections);
              const close = this.querySelector('[data-cart-close]');
              if (close) close.focus();
            })
            .catch(() => {
              window.location.href = window.LaunchStudio.routes.root + 'cart';
            })
            .finally(() => this.removeAttribute('aria-busy'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ls-hero-3d')) {
    customElements.define(
      'ls-hero-3d',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.capable()) return;
          this.stage = this.closest('[data-hero-stage]');
          this.controls = this.stage && this.stage.querySelector('[data-hero-controls]');
          this.onReady = () => {
            if (!this.stage) return;
            this.stage.classList.add('is-3d');
            if (this.controls) this.controls.hidden = false;
          };
          this.onFallback = () => {
            if (!this.stage) return;
            this.stage.classList.remove('is-3d');
            if (this.controls) this.controls.hidden = true;
            if (this.controller) this.controller.destroy();
            this.controller = null;
          };
          this.onState = (event) => this.syncButtons(event.detail.target);
          this.addEventListener('ls:hero3d-ready', this.onReady);
          this.addEventListener('ls:hero3d-fallback', this.onFallback);
          this.addEventListener('ls:hero3d-state', this.onState);
          if (this.controls) {
            this.controls.addEventListener('click', (event) => {
              const button = event.target.closest('button');
              if (!button || !this.controller) return;
              if (button.hasAttribute('data-replay')) this.controller.replay();
              else this.controller.setTarget(Number(button.dataset.target));
            });
          }
          const load = () => {
            if (!this.isConnected) return;
            const reducedMotion =
              !document.documentElement.classList.contains('motion-ok') ||
              window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            import(this.dataset.src)
              .then((module) => module.mount(this, { strings: JSON.parse(this.dataset.strings), reducedMotion }))
              .then((controller) => {
                if (this.isConnected) this.controller = controller;
                else controller.destroy();
              })
              .catch(() => this.onFallback());
          };
          if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 2500 });
          else window.setTimeout(load, 1200);
        }

        disconnectedCallback() {
          if (this.controller) this.controller.destroy();
          this.controller = null;
        }

        syncButtons(target) {
          if (!this.controls) return;
          this.controls.querySelectorAll('[data-target]').forEach((button) => {
            button.setAttribute('aria-pressed', String(Number(button.dataset.target) === target));
          });
        }

        capable() {
          const nav = navigator;
          if (nav.connection && nav.connection.saveData) return false;
          if (nav.deviceMemory && nav.deviceMemory < 4) return false;
          if (nav.hardwareConcurrency && nav.hardwareConcurrency < 4) return false;
          try {
            const probe = document.createElement('canvas');
            return !!(probe.getContext('webgl2') || probe.getContext('webgl'));
          } catch (error) {
            return false;
          }
        }
      }
    );
  }

  if (!customElements.get('ls-sticky-buy')) {
    customElements.define(
      'ls-sticky-buy',
      class extends HTMLElement {
        connectedCallback() {
          if (!('IntersectionObserver' in window)) return;
          this.hidden = false;
          this.hero = document.querySelector('[data-hero]');
          this.visibleButtons = new Set();
          this.pastHero = false;
          this.heroObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            });
            this.update();
          }, { rootMargin: '-140px 0px 0px 0px' });
          if (this.hero) this.heroObserver.observe(this.hero);
          this.buttonObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.visibleButtons.add(entry.target);
              else this.visibleButtons.delete(entry.target);
            });
            this.update();
          });
          document.querySelectorAll('main [data-add-button]').forEach((button) => {
            if (!this.contains(button) && !(this.hero && this.hero.contains(button))) this.buttonObserver.observe(button);
          });
          /* Stay out of the way of the footer's legal and policy links. */
          const footer = document.querySelector('.shopify-section-group-footer-group, body > footer');
          if (footer) this.buttonObserver.observe(footer);
        }

        disconnectedCallback() {
          if (this.heroObserver) this.heroObserver.disconnect();
          if (this.buttonObserver) this.buttonObserver.disconnect();
        }

        update() {
          const show = this.pastHero && this.visibleButtons.size === 0;
          this.classList.toggle('is-shown', show);
          this.inert = !show;
        }
      }
    );
  }

  if (!customElements.get('ls-spotlight')) {
    customElements.define(
      'ls-spotlight',
      class extends HTMLElement {
        connectedCallback() {
          const allowed =
            document.documentElement.classList.contains('motion-ok') &&
            window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          if (!allowed) return;
          this.zone = this.parentElement;
          this.frame = null;
          this.onMove = (event) => {
            const rect = this.zone.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            if (this.frame) cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => {
              this.style.setProperty('--mx', x + 'px');
              this.style.setProperty('--my', y + 'px');
            });
          };
          this.zone.addEventListener('pointermove', this.onMove);
        }

        disconnectedCallback() {
          if (this.zone) this.zone.removeEventListener('pointermove', this.onMove);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["code-vault"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ls-code-copy')) {
    customElements.define(
      'ls-code-copy',
      class extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('[data-copy]');
          if (!button) return;
          button.addEventListener('click', () => {
            const code = this.querySelector('[data-code]').textContent;
            const done = () => {
              const label = this.querySelector('[data-copy-label]');
              const original = label.textContent;
              label.textContent = this.dataset.copied;
              button.classList.add('is-done');
              setTimeout(() => {
                label.textContent = original;
                button.classList.remove('is-done');
              }, 2000);
            };
            // Some in-app browsers block the async clipboard; fall back to a hidden textarea.
            const fallback = () => {
              const t = document.createElement('textarea');
              t.value = code;
              t.setAttribute('readonly', '');
              t.style.position = 'fixed';
              t.style.opacity = '0';
              document.body.appendChild(t);
              t.select();
              try { if (document.execCommand('copy')) done(); } catch (e) {}
              t.remove();
            };
            if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback);
            else fallback();
          });
        }
      }
    );
  }

  if (!customElements.get('vault-frame')) {
    customElements.define(
      'vault-frame',
      class extends HTMLElement {
        connectedCallback() {
          const frame = this.querySelector('[data-frame]');
          this.querySelectorAll('[data-view]').forEach((b) => {
            b.addEventListener('click', () => {
              this.querySelectorAll('[data-view]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
              frame.classList.toggle('vault-frame--phone', b.dataset.view === 'phone');
              frame.classList.toggle('vault-frame--desktop', b.dataset.view === 'desktop');
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ls-bento')) {
    customElements.define(
      'ls-bento',
      class extends HTMLElement {
        connectedCallback() {
          const allowed =
            document.documentElement.classList.contains('motion-ok') &&
            window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          if (!allowed) return;
          this.tiles = Array.from(this.querySelectorAll('.bento__tile'));
          this.frame = null;
          this.onMove = (event) => {
            if (this.frame) cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => {
              this.tiles.forEach((tile) => {
                const rect = tile.getBoundingClientRect();
                tile.style.setProperty('--tx', event.clientX - rect.left + 'px');
                tile.style.setProperty('--ty', event.clientY - rect.top + 'px');
              });
            });
          };
          this.onLeave = () => {
            this.tiles.forEach((tile) => {
              tile.style.removeProperty('--tx');
              tile.style.removeProperty('--ty');
            });
          };
          this.addEventListener('pointermove', this.onMove);
          this.addEventListener('pointerleave', this.onLeave);
        }

        disconnectedCallback() {
          this.removeEventListener('pointermove', this.onMove);
          this.removeEventListener('pointerleave', this.onLeave);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-launch-studio"]) return;
  try {
    
  if (!customElements.get('ls-header')) {
    customElements.define(
      'ls-header',
      class extends HTMLElement {
        connectedCallback() {
          this.menu = this.querySelector('dialog');
          this.openButton = this.querySelector('[data-menu-open]');
          this.onScroll = this.onScroll.bind(this);
          this.ticking = false;
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();

          if (this.menu && this.openButton) {
            this.openButton.addEventListener('click', () => {
              this.menu.showModal();
              this.openButton.setAttribute('aria-expanded', 'true');
            });
            this.menu.addEventListener('close', () => {
              this.openButton.setAttribute('aria-expanded', 'false');
              if (!this.followingLink) this.openButton.focus();
              this.followingLink = false;
            });
            this.menu.querySelector('[data-menu-close]').addEventListener('click', () => this.menu.close());
            this.menu.querySelectorAll('[data-menu-link]').forEach((link) => {
              link.addEventListener('click', () => {
                this.followingLink = true;
                this.menu.close();
              });
            });
          }

          this.onCartUpdate = (event) => this.setCount(event.detail.count);
          document.addEventListener('ls:cart-updated', this.onCartUpdate);
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          document.removeEventListener('ls:cart-updated', this.onCartUpdate);
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.classList.toggle('is-scrolled', window.scrollY > 8);
            this.ticking = false;
          });
        }

        setCount(count) {
          const badge = this.querySelector('[data-cart-count-badge]');
          const link = this.querySelector('[data-cart-open]');
          if (badge) {
            badge.textContent = count;
            badge.hidden = count === 0;
          }
          if (link && link.dataset.labelTemplate) {
            link.setAttribute('aria-label', link.dataset.labelTemplate.replace('__COUNT__', count));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-calc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('calc');
    if (!form) return;
    var inr = function (n) { return (n < 0 ? '−₹' : '₹') + Math.round(Math.abs(n)).toLocaleString('en-IN'); };
    var num = function (n) { return Math.round(n).toLocaleString('en-IN'); };
    var outs = function (k) { return form.querySelectorAll('[data-o="' + k + '"]'); };
    var set = function (k, text) { outs(k).forEach(function (el) { if (el.textContent !== text) el.textContent = text; }); };
    // The last valid value of each field: a half-typed or empty box never reaches the maths.
    var good = {};
    function clampTo(box, v) { return Math.min(Math.max(v, parseFloat(box.min)), parseFloat(box.max)); }
    function get(name) {
      var box = form.elements[name], v = parseFloat(box.value);
      if (isFinite(v) && v >= parseFloat(box.min) && v <= parseFloat(box.max)) good[name] = v;
      return good[name] !== undefined ? good[name] : clampTo(box, parseFloat(box.defaultValue) || 0);
    }

    function run() {
      // The same spend buys the same visitors in both stores; only the share who buy changes.
      var spend = get('budget') * 30;
      var visitors = Math.floor(spend / get('cpc'));
      // Every order pays product + shipping; returned (RTO) orders bring no revenue back.
      var price = get('price'), cost = get('cost'), rto = get('rto') / 100;
      var perOrder = (1 - rto) * price - cost;
      var col = function (rate) {
        var orders = Math.round(visitors * rate / 100);
        var returned = Math.round(orders * rto), delivered = orders - returned;
        return { orders: orders, returned: returned, cpp: delivered > 0 ? spend / delivered : null, rev: delivered * price, profit: delivered * price - orders * cost - spend };
      };
      // Ecomlab's rate is fixed; today's slider stops below it, so the Ecomlab column is always the higher one.
      var crB = get('cr_b'), crA = parseFloat(form.dataset.crAfter) || 7;
      var b = col(crB), a = col(crA);
      set('cr_a', crA + '%');
      set('spend', inr(spend));
      set('visitors', num(visitors));
      set('orders_b', num(b.orders)); set('orders_a', num(a.orders));
      set('rto_b', num(b.returned)); set('rto_a', num(a.returned));
      set('cpp_b', b.cpp === null ? '–' : inr(b.cpp)); set('cpp_a', a.cpp === null ? '–' : inr(a.cpp));
      set('rev_b', inr(b.rev)); set('rev_a', inr(a.rev));
      set('profit_b', inr(b.profit)); set('profit_a', inr(a.profit));
      outs('profit_b').forEach(function (el) { el.classList.toggle('is-loss', b.profit < 0); });
      outs('profit_a').forEach(function (el) { el.classList.toggle('is-loss', a.profit < 0); });
      // Extra profit only means something while an average order (after RTO) makes money.
      // At tiny volumes, whole-order rounding can tip a few rupees either way; never show a negative gain.
      var gain = perOrder > price * 0.01 ? Math.max(a.profit - b.profit, 0) : 0;
      set('gain_m', inr(gain));
      set('gain_y', inr(gain * 12));
      form.querySelector('[data-o-yes]').hidden = gain <= 0;
      form.querySelector('[data-o-no]').hidden = gain > 0;
      var kit = parseFloat(window.lxPayPrice || form.dataset.kitPrice) || 299;
      var perDay = gain / 30, pay = '–';
      if (perDay > 0) {
        var hours = (kit / perDay) * 24;
        pay = hours < 1 ? 'under an hour' : hours < 48 ? Math.round(hours) + (Math.round(hours) === 1 ? ' hour' : ' hours') : Math.round(hours / 24) + ' days';
      }
      set('payback', pay);
    }

    // Dragging fires many input events a frame; the maths and the writes run once per frame.
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; run(); });
    }

    // Slider and number box stay in step; typing never fights the cursor, leaving the box tidies it up.
    form.querySelectorAll('.calc__range').forEach(function (r) {
      var box = form.elements[r.dataset.for];
      r.addEventListener('input', function () { box.value = r.value; schedule(); });
      box.addEventListener('input', function () {
        var v = parseFloat(box.value);
        if (isFinite(v)) r.value = clampTo(box, v);
        schedule();
      });
      box.addEventListener('change', function () {
        var v = parseFloat(box.value);
        v = isFinite(v) ? clampTo(box, v) : get(r.dataset.for);
        box.value = v;
        r.value = v;
        good[r.dataset.for] = v;
        run();
      });
    });
    window.addEventListener('lx:price', run);
    run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["self-check"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ls-self-check')) {
    customElements.define(
      'ls-self-check',
      class extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.selfcheck__item'));
          this.addEventListener('click', (event) => {
            const item = event.target.closest('.selfcheck__item');
            if (!item) return;
            item.setAttribute('aria-pressed', String(item.getAttribute('aria-pressed') !== 'true'));
            this.update();
          });
        }

        update() {
          const count = this.items.filter((item) => item.getAttribute('aria-pressed') === 'true').length;
          const meter = this.querySelector('[data-meter]');
          const message = this.querySelector('[data-message]');
          const link = this.querySelector('[data-link]');
          this.querySelector('[data-count]').textContent = count;
          meter.hidden = count === 0;
          if (link) link.hidden = count === 0;
          if (count === 0) message.textContent = '';
          else if (count === 1) message.textContent = this.dataset.one;
          else message.textContent = this.dataset.many;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-transformation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ls-compare')) {
    customElements.define(
      'ls-compare',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = this.querySelector('.compare__frame');
          this.range = this.querySelector('.compare__range');
          this.flag = this.querySelector('[data-after-flag]');
          this.range.addEventListener('input', () => this.frame.style.setProperty('--pos', this.range.value + '%'));
          /* Direct drag anywhere on the frame (touch, pen, mouse); the range stays for keyboard and screen readers. */
          const setFromPointer = (event) => {
            const rect = this.frame.getBoundingClientRect();
            const value = Math.round(Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100)));
            this.range.value = value;
            this.frame.style.setProperty('--pos', value + '%');
          };
          this.frame.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'mouse' && event.button !== 0) return;
            this.dragging = true;
            this.frame.setPointerCapture(event.pointerId);
            setFromPointer(event);
          });
          this.frame.addEventListener('pointermove', (event) => {
            if (this.dragging) setFromPointer(event);
          });
          const stop = () => {
            this.dragging = false;
          };
          this.frame.addEventListener('pointerup', stop);
          this.frame.addEventListener('pointercancel', stop);
          this.querySelectorAll('[data-after]').forEach((tab) => {
            tab.addEventListener('click', () => this.show(Number(tab.dataset.after), tab));
          });
        }

        show(index, tab) {
          this.querySelectorAll('[data-after]').forEach((item) => item.setAttribute('aria-pressed', String(item === tab)));
          this.querySelectorAll('[data-after-pane]').forEach((pane) => {
            pane.hidden = Number(pane.dataset.afterPane) !== index;
          });
          this.querySelectorAll('[data-after-caption]').forEach((caption) => {
            caption.hidden = Number(caption.dataset.afterCaption) !== index;
          });
          if (this.flag) this.flag.textContent = tab.textContent.trim();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storefront-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ls-tabs')) {
    customElements.define(
      'ls-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index, true));
            tab.addEventListener('keydown', (event) => this.onKey(event, index));
          });
          const selected = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
          this.select(selected, false);
        }

        onKey(event, index) {
          const last = this.tabs.length - 1;
          let next = null;
          if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
          if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = last;
          if (next === null) return;
          event.preventDefault();
          this.select(next, true);
          this.tabs[next].focus();
        }

        select(index, animate) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            const panel = this.panels[i];
            if (!panel) return;
            panel.hidden = !active;
            if (active) {
              panel.setAttribute('data-shown', '');
              if (animate) {
                panel.classList.remove('is-entering');
                void panel.offsetWidth;
                panel.classList.add('is-entering');
              }
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
